import * as Cookies from 'js-cookie'

let cookies = {};

export const setCookiesObject = (newCookies) => {
  cookies = newCookies;
}

export const getCookiesObject = () => {
  if (typeof window !== 'undefined') {
    return Cookies;
  } else {
    return cookies;
  }
};


// WEBPACK FOOTER //
// ./webapp/scripts/cookies.js